import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import SupplyChain from "../../components/supply-chain";

function SupplyChainPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Supply Chain Management | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Supply Chain Management"} t={t} />
      <SupplyChain />
    </>
  );
}

export default SupplyChainPage;
